import React from 'react';

export const LazyHeManagementPage = React.lazy(() => import('./HeManagementPage'));
export const LazyHeApprovalPage = React.lazy(() => import('./HeApprovalPage'));
export const LazyHeSettingPage = React.lazy(() => import('./HeSettingPage'));
